import "./Shop.css";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";

const GalleryDataShop = ({ imageKeys, galleryData }) => {
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [dataToShow, setDataToShow] = useState(["", ["", "", ""]]); // [key, [title, desc, price]]

  const open = (key) => {
    const meta = galleryData?.[key] || ["", "", ""];
    setDataToShow([key, meta]);
    setShow(true);
  };

  const close = () => setShow(false);

  const contact = () => {
    // Send only the metadata to Contact page
    navigate("/Contact", { state: { artwork: dataToShow[1] } });
  };

  return (
    <>
      {/* Grid: center items and align them to the top */}
      <div className="row justify-content-center align-items-start">
        {imageKeys.map((key) => {
          const meta = galleryData?.[key];
          if (!meta) return null;

          const [title, desc] = meta;
          const label = title ?? desc ?? key;

          return (
            <div
              key={key}
              className="
                col-6 col-md-4 col-lg-3
                d-flex justify-content-center align-items-start
              "
            >
              {/* Responsive margins: m-2 on mobile, m-5 on md+ */}
              <div
                className="
                  mx-2 my-2 mx-md-5 my-md-5
                  d-flex justify-content-center align-items-start
                "
              >
                <div className="galleryCard" onClick={() => open(key)}>
                  <img
                    className="galleryImg img-fluid align-self-start"
                    src={`/images/Gallery/${key}.jpg`}
                    alt={label}
                  />
                  <div className="imgInfo">
                    {label && <div>{label}</div>}
                    {title && desc && <div className="imgInfo__sub">{desc}</div>}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Modal */}
      <Modal show={show} onHide={close} size="lg" centered>
        <Modal.Body>
          <div className="container-fluid">
            <div className="row gy-3 align-items-center">
              <div className="col-12 col-md-6 d-flex justify-content-center align-items-start">
                <img
                  className="img-fluid modalImg align-self-start"
                  src={`/images/Gallery/${dataToShow[0]}.jpg`}
                  alt={dataToShow[1][0] || dataToShow[1][1] || dataToShow[0]}
                />
              </div>
              <div className="col-12 col-md-6 d-flex align-items-start">
                <div className="shopMeta">
                  {dataToShow[1][0] ? (
                    <>
                      <div className="shopMeta__title">{dataToShow[1][0]}</div>
                      <div className="shopMeta__desc">{dataToShow[1][1]}</div>
                    </>
                  ) : (
                    <div className="shopMeta__title">{dataToShow[1][1]}</div>
                  )}
                  <div className="shopMeta__price">{dataToShow[1][2]}</div>

                  <div className="d-flex gap-2 justify-content-end mt-4">
                    <Button variant="secondary" onClick={close} className="shopBtn">
                      Close
                    </Button>
                    <Button variant="primary" onClick={contact} className="shopBtn">
                      I'm interested
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GalleryDataShop;
